import React, { useState } from 'react';
import { useStore } from '@/store';
import { X } from 'lucide-react';

export function FloatingActionPanel() {
  const { selectedDots, clearDotSelections } = useStore();
  const [prompt, setPrompt] = useState('');

  if (selectedDots.length === 0) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement insight generation
    console.log('Generating insight with prompt:', prompt);
    console.log('Selected items:', selectedDots);
  };

  return (
    <div 
      className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 
                 bg-white rounded-lg shadow-lg border border-gray-200 
                 w-[600px] max-w-[90vw]"
    >
      <form 
        onSubmit={handleSubmit}
        className="p-4"
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-700">
              {selectedDots.length} item{selectedDots.length !== 1 ? 's' : ''} selected
            </span>
            <button
              type="button"
              onClick={clearDotSelections}
              className="text-gray-500 hover:text-gray-700"
              title="Clear selection"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div className="flex gap-3">
          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Enter a prompt for insight generation..."
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md 
                       focus:outline-none focus:ring-2 focus:ring-blue-500 
                       focus:border-transparent"
          />
          <button
            type="submit"
            disabled={!prompt.trim()}
            className="px-4 py-2 bg-blue-500 text-white rounded-md
                     hover:bg-blue-600 transition-colors
                     disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Generate Insight
          </button>
        </div>
      </form>
    </div>
  );
} 